import {
  useListNotes,
  useListLabels,
  useListImageTemplates,
  useListViewsTemplates,
  useGenericTables,
  useManualPartsTables,
  useAutoPartsTable,
  useManualToolsTables,
  useAutoToolsTable,
} from '@/services/hooks/template_attributes'

export const useOperationPageTemplateAttributes = ({
  documentPageId,
}: {
  documentPageId?: string | null
}) => {
  const notesTemplates = useListNotes(documentPageId)
  const labelTemplates = useListLabels(documentPageId)

  const imageTemplates = useListImageTemplates(documentPageId)
  const viewTemplates = useListViewsTemplates(documentPageId)

  const genericTables = useGenericTables(documentPageId)
  const manualPartsTables = useManualPartsTables(documentPageId)
  const autoPartsTable = useAutoPartsTable(documentPageId)
  const manualToolsTables = useManualToolsTables(documentPageId)
  const autoToolsTable = useAutoToolsTable(documentPageId)

  return {
    notesTemplates,
    labelTemplates,
    imageTemplates,
    viewTemplates,
    genericTables,
    manualPartsTables,
    autoPartsTable: autoPartsTable,
    manualToolsTables,
    autoToolsTable: autoToolsTable,
  }
}
